export default __webpack_public_path__ + "static/media/autoProLogo_en.93d3a5a7.png";